import { render } from "./AddShipyard.vue?vue&type=template&id=7fe0741a&scoped=true"
import script from "./AddShipyard.vue?vue&type=script&lang=ts"
export * from "./AddShipyard.vue?vue&type=script&lang=ts"

import "./AddShipyard.vue?vue&type=style&index=0&id=7fe0741a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7fe0741a"

export default script